"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuTab = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _UserSection = require("../../UserSection");
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BurgerMenuTab = ({
  children,
  activeTab,
  tabPrefix,
  tabName,
  onTabClick,
  isLoggedIn,
  fullWidth = false
}) => {
  const clickHandler = (0, _react.useCallback)(() => onTabClick(tabName), [onTabClick, tabName]);
  const TabIcon = tabPrefix;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuTabRoot, {
    disableRipple: true,
    fullWidth: fullWidth,
    isActive: activeTab === tabName,
    "data-testid": getTestId(_constants.BURGER_MENU_TAB_ROOT),
    onClick: clickHandler,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuTabPrefixWrapper, {
      isLoggedIn: isLoggedIn,
      "data-testid": getTestId(_constants.BURGER_MENU_TAB_ICON_WRAPPER),
      children: typeof tabPrefix === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserSection.UserAvatar, {
        "data-testid": getTestId(_constants.TAB_ICON),
        children: tabPrefix
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(TabIcon, {
        fontSize: "inherit",
        "data-testid": getTestId(_constants.TAB_ICON)
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuTabLabelWrapper, {
      "data-testid": getTestId(_constants.BURGER_MENU_TAB_LABEL_WRAPPER),
      fullWidth: fullWidth,
      children: children
    })]
  });
};
exports.BurgerMenuTab = BurgerMenuTab;